"use strict";import{IconCross200 as o}from"../src/elements/IconCross200.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-cross200",o);
//# sourceMappingURL=sp-icon-cross200.js.map
